<template>
  <div class="tw-flex tw-gap-2 tw-justify-end tw-items-center">
    <span class="tw-text-xs">Source</span>
    <svg-vue
      icon="logos/google-analytics"
      class="tw-h-3"
    />
  </div>
</template>
<script setup>
</script>